import { createQueryKeys } from '@lukemorales/query-key-factory';
import { axios } from '@repo/http';
import { useQuery } from '@tanstack/react-query';
import { GET_ORGANIZATION_AVAILABLE_PATH } from 'ze-api-contract/organization-v1/get-organization-available';
// todo::update to v2 API
const v1OrganizationListAvailable = createQueryKeys('organization', {
    listAvailable: ()=>({
            queryKey: [
                GET_ORGANIZATION_AVAILABLE_PATH
            ],
            queryFn: ()=>axios.get(GET_ORGANIZATION_AVAILABLE_PATH).then((res)=>res.data)
        })
});
/** @deprecated - use `my` organizations */ export function useOrganizationListAvailable() {
    const { data: availableOrganizations, isLoading, error } = useQuery(v1OrganizationListAvailable.listAvailable());
    return {
        availableOrganizations,
        isLoading,
        error
    };
}
